const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evaluate - evaluate metaTagFormTypeOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const cacheKey = await sourceEvaluator(source.name);
  if (cacheKey === undefined) {
    return {};
  }
  const metaTagOptions = (await sourceEvaluator({
    type: 'getCacheValueBehavior',
    name: cacheKey
  })) || {};
  const formTypeOptions = {};
  Object.keys(metaTagOptions).forEach(key => {
    const _metaTagOptions$key = metaTagOptions[key],
      title = _metaTagOptions$key.title,
      _created = _metaTagOptions$key._created,
      children = _metaTagOptions$key.children;
    if (children !== undefined && Object.keys(children).length > 0) {
      formTypeOptions[key] = {
        title,
        _created
      };
    }
  });
  return formTypeOptions;
};
module.exports = {
  evaluate
};